import type { App } from '@grafikr/components';
import Cart from 'utils/cart';

export default (app: App) => {
  app.emitter.on('cart:added', () => {
    Cart.get({
      success: (body) => {
        theme.cart = body;
        app.emitter.emit('cart:updated', body);
      },
    });
  });
};
